<template>
  <div class="col-sm-12 order-items">
    <div class="order-item-details tracking">
      <div class="row">
        <div class="col-md-12 text-center">
          <h3>{{ order.StoreName }}</h3>
          <h4>{{ store.Location.Address }}</h4>
          <div v-if="order.OrderNumber">Order #{{ order.OrderNumber }}</div>
          <div class="tracking-date">{{ getCreateDate() }}</div>
        </div>
      </div>
      <div class="row" v-if="!isTwoColumn && updateDisplayModel.status > -1">
        <div
          v-if="updateDisplayModel.status < 4"
          class="col-sm-12 d-flex justify-content-center multi-steps-wrapper"
        >
          <ul class="list-unstyled multi-steps">
            <li :style="getStylesColor(1)">
              <span :style="getBeforStyle(1)"></span>
              <span>{{ $t("message.pending") }}&nbsp;</span>
              <span :style="getAfterStyle(1)"></span>
            </li>
            <li :style="getStylesColor(2)">
              <span :style="getBeforStyle(2)"></span>
              <span>{{ $t("message.preparing") }}&nbsp;</span>
              <span :style="getAfterStyle(2)"></span>
            </li>
            <li :style="getStylesColor(3)">
              <span :style="getBeforStyle(3)"></span>
              <span v-if="order.OrderType === 10 || order.OrderType === 2">{{
                $t("message.onItsWay")
              }}</span>
              <span v-else>{{ $t("message.readyForPickup") }}</span>
            </li>
          </ul>
        </div>
        <h2
          class="w-100 text-center"
          v-else-if="updateDisplayModel.status == 4 && isCompletedOrder"
        >
          {{ $t("message.orderCompleted") }}
        </h2>
        <h2
          class="w-100 text-center"
          v-else-if="updateDisplayModel.status == 5"
        >
          {{ $t("message.orderRefunded") }}
        </h2>
        <h2
          class="w-100 text-center"
          v-else-if="updateDisplayModel.status == 6"
        >
          {{ $t("message.orderCancelRequest") }}
        </h2>
      </div>
      <div v-else-if="isTwoColumn && updateDisplayModel.status > -1">
        <h2
          class="text-center"
          v-if="
            updateDisplayModel.status == 0 || updateDisplayModel.status == 3
          "
        >
          {{ $t("message.pending") }}
        </h2>
        <h2
          class="text-center"
          v-if="
            updateDisplayModel.status > 0 &&
            updateDisplayModel.status < 5 &&
            updateDisplayModel.status != 3
          "
        >
          {{ $t("message.orderAccepted") }}
        </h2>
        <h2 class="text-center" v-if="updateDisplayModel.status == 5">
          {{ $t("message.orderRefunded") }}
        </h2>
        <h2 class="text-center" v-if="updateDisplayModel.status == 6">
          {{ $t("message.orderCancelRequest") }}
        </h2>
      </div>
      <div class="row mt-2" v-else-if="updateDisplayModel.status < 0">
        <div class="col-sm-12 text-center d-flex justify-content-center">
          <div
            v-if="
              updateDisplayModel.status == -1 || updateDisplayModel.status == -3
            "
            class="text-danger text-size-9"
          >
            <div v-if="isOrderFailed">
              <p>
                {{ $t("message.orderFaildMessageLine1") }}.
                <br />
                {{ gerOrderFaildLine2Message }}.
                <br />
                {{ $t("message.orderFaildMessageLine3") }}.
              </p>
            </div>
            <div v-else>
              <p>
                {{ $t("message.yourOrderHasBeenRejected") }}
                <br />
                {{ order.OnlineOrderStatusDescription }}
                <br />
                {{
                  order.OnlineOrderStatus != 20
                    ? $t("message.YourPaymentWillBeRefunded")
                    : ""
                }}
              </p>
            </div>
          </div>
          <div
            v-else-if="updateDisplayModel.status == -2"
            class="text-danger text-size-9"
          >
            <div>
              <p>
                {{ $t("message.paymentFaildMessageLine1") }}.
                <br />
                {{ $t("message.paymentFaildMessageLine2") }}.
                <br />
                {{ $t("message.paymentFaildMessageLine3") }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOrderStatus } from "../../../api/helpers/orderHelper";
import { mapGetters, mapMutations } from "vuex";
import { DateTime } from "luxon";
import { interpolate } from "../../../api/helpers/stringHelper";
export default {
  name: "TrackingComponent",
  props: {
    isCompletedOrder: {
      type: Boolean,
      default: true,
    },
    order: {
      type: Object,
      default: () => {},
    },
    store: {
      type: Object,
      default: () => {},
    },
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"]),
    updateDisplayModel() {
      var displayModel = {};
      //update status
      displayModel.status = getOrderStatus(this.order);
      switch (displayModel.status) {
        case -3:
          if (this.isOrderFailed)
            displayModel.orderMode = this.$t("message.orderFaild");
          else displayModel.orderMode = this.$t("message.orderRejected");
          break;
        case -2:
          displayModel.orderMode = this.$t("message.paymentFaild");
          break;
        case -1:
          displayModel.orderMode = this.$t("message.orderRejected");
          break;
        case 0:
          displayModel.orderMode = this.$t("message.orderSent");
          break;
        case 3:
          displayModel.orderMode = this.$t("message.orderSubmitted");
          break;
        case 1:
          displayModel.orderMode = this.$t("message.beingPrepared");
          break;
        case 2:
          if (this.order.OrderType === 10 || this.order.OrderType === 2)
            displayModel.orderMode = this.$t("message.onItsWay");
          else displayModel.orderMode = this.$t("message.readyForPickup");
          break;
        case 4:
          displayModel.orderMode = this.$t("message.orderCompleted");
          break;
        case 5:
          displayModel.orderMode = this.$t("message.orderRefunded");
          break;
        case 6:
          displayModel.orderMode = this.$t("message.orderCancelRequest");
          break;
      }

      this.$emit("update-status", displayModel.orderMode);
      return displayModel;
    },
    isOrderFailed() {
      if (
        this.order.OnlineOrderStatusDescription &&
        this.order.OnlineOrderStatusDescription.indexOf(
          "We’re having problems reaching the store"
        ) > -1
      ) {
        return true;
      }
      return false;
    },
    gerOrderFaildLine2Message() {
      return interpolate(
        this.$t("message.orderFaildMessageLine2"),
        this.store.Name,
        this.store.OfficePhone
      );
    },
    isTwoColumn() {
      return (
        this.store.IsDisableStatusTracking ||
        (this.order.OnlineOrderStatus >= 18 &&
          this.order.OnlineOrderStatus <= 20)
      );
    },
  },
  methods: {
    ...mapMutations(["addUserOrderHistory"]),
    getCreateDate() {
      if (this.order.CreatedOn)
        return DateTime.fromJSDate(
          new Date(this.order.CreatedOn.seconds * 1000)
        ).toFormat("dd MMMM yyyy h:mm a");
    },
    getBeforStyle(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 4
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
        case 2:
          if (
            (this.updateDisplayModel.status >= 1 &&
              this.updateDisplayModel.status <= 2) ||
            this.updateDisplayModel.status == 4
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
        case 3:
          if (
            this.updateDisplayModel.status == 2 ||
            this.updateDisplayModel.status == 4 ||
            (this.isTwoColumn && this.updateDisplayModel.status == 1)
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
      }
      return styles;
    },
    getAfterStyle(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            (this.updateDisplayModel.status >= 1 &&
              this.updateDisplayModel.status <= 2) ||
            this.updateDisplayModel.status == 4
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterCommonColor
                : this.desktopStyles.stepProgressBarAfterCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterPendingColor
                : this.desktopStyles.stepProgressBarAfterPendingColor
            );
          break;
        case 2:
          if (
            this.updateDisplayModel.status == 2 ||
            this.updateDisplayModel.status == 4
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterCommonColor
                : this.desktopStyles.stepProgressBarAfterCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterPendingColor
                : this.desktopStyles.stepProgressBarAfterPendingColor
            );
          break;
      }
      return styles;
    },
    getStylesColor(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 4
          )
            styles.push({ color: "#55696d" });
          else styles.push({ color: "#cfdafd" });
          break;
        case 2:
          if (
            (this.updateDisplayModel.status >= 1 &&
              this.updateDisplayModel.status <= 2) ||
            this.updateDisplayModel.status == 4
          )
            styles.push({ color: "#55696d" });
          else styles.push({ color: "#cfdafd" });
          break;
        case 3:
          if (
            this.updateDisplayModel.status == 2 ||
            this.updateDisplayModel.status == 4 ||
            (this.isTwoColumn && this.updateDisplayModel.status == 1)
          )
            styles.push({ color: "#55696d" });
          else styles.push({ color: "#cfdafd" });
          break;
      }
      return styles;
    },
  },
};
</script>
